'use strict';

module.exports = require('./time-helper.js');